/**
 * Utilities to help with label-related UI code
 */ /**
 * Get text to show in UI for the given label. If label name is empty or null, return the default string.
 * @param label the label to get display text for
 */ export function getLabelPlaceholder(label) {
    if (label.name == null || label.name === "") {
        return label.placeholderText;
    }
    return label.name;
}
/**
 * Sort labels in a way that is user friendly and aesthetically pleasing.
 * Group used labels at the top (beginning), and the rest after.
 * In each group, sort by index to keep the colors roughly rainbow-sorted.
 * @param labels The labels to be sorted for suggestion UI
 */ export function sortLabelsByUsageAndIndex(labels) {
    const usedLabels = labels.filter((label)=>label.usageCount && label.usageCount > 0).sort(compareLabelsByIndex);
    const unusedLabels = labels.filter((label)=>label.usageCount == null || label.usageCount <= 0).sort(compareLabelsByIndex);
    const sortedLabels = [];
    sortedLabels.push(...usedLabels);
    sortedLabels.push(...unusedLabels);
    return sortedLabels;
}
/**
 * Compare labels by index number only
 * @param label1 The first label to compare
 * @param label2 The second label to compare
 */ export function compareLabelsByIndex(label1, label2) {
    return label1.index === label2.index ? 0 : label1.index < label2.index ? -1 : 1;
}
